import axiosInstance from "../../utils/axios";

export const webContactLinksApi = {
  // PMS Admin Management
  getAll: (frontendOrigin = typeof window !== "undefined" ? window.location.origin : undefined) => {
    return axiosInstance.get("/api/hotel/contact-links", {
      params: { frontendOrigin },
    });
  },

  getById: (id, frontendOrigin = typeof window !== "undefined" ? window.location.origin : undefined) => {
    return axiosInstance.get(`/api/hotel/contact-links/${id}`, {
      params: { frontendOrigin },
    });
  },

  create: (payload, frontendOrigin = typeof window !== "undefined" ? window.location.origin : undefined) => {
    return axiosInstance.post("/api/hotel/contact-links", payload, {
      params: { frontendOrigin },
    });
  },

  update: (id, payload, frontendOrigin = typeof window !== "undefined" ? window.location.origin : undefined) => {
    return axiosInstance.put(`/api/hotel/contact-links/${id}`, payload, {
      params: { frontendOrigin },
    });
  },

  delete: (id) => {
    return axiosInstance.delete(`/api/hotel/contact-links/${id}`);
  },

  regenerateToken: (id, frontendOrigin = typeof window !== "undefined" ? window.location.origin : undefined) => {
    return axiosInstance.post(`/api/hotel/contact-links/${id}/regenerate-token`, null, {
      params: { frontendOrigin },
    });
  },

  // Public Anonymous Visitor Endpoints
  getPublicMetadata: (token) => {
    return axiosInstance.get(`/api/public/contact-links/${token}`);
  },

  submitInquiry: (token, payload) => {
    return axiosInstance.post(`/api/public/contact-links/${token}/inquiry`, payload);
  },

  recordCallPlaced: (token) => {
    return axiosInstance.post(`/api/public/contact-links/${token}/record-call`);
  },
};
